import { Component } from 'react';
import styled from 'styled-components';
import { USER_MENU_DROPDOWN_WIDTH } from '../constants';
import { COLOR_WHITE } from '../../../components/commander-ui';
import { ProfileDivider } from './styles';
import { UserMenuNavigationList } from './UserMenuNavigationList';
import UserMenuList from './UserMenuList';
import ProfileCard from './ProfileCard';

interface UserMenuContentProps {
    close(): void;
}

class UserMenuContent extends Component<UserMenuContentProps> {
    handleOnItemClick = () => {
        this.props.close();
    };

    render() {
        const { close, ...others } = this.props;
        return (
            <UserMenuContentContainer {...others}>
                <ProfileCard />
                <ProfileDivider />
                <UserMenuList close={close} />
                <UserMenuNavigationList onItemClick={this.handleOnItemClick} />
            </UserMenuContentContainer>
        );
    }
}

export default UserMenuContent;

const UserMenuContentContainer = styled.div`
    width: ${USER_MENU_DROPDOWN_WIDTH};
    max-width: 95vw;
    background-color: ${COLOR_WHITE};
`;
